import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Card, DatePicker } from "antd";
import CustomInput from "../../common/CustomInput";
import CustomButton from "../../common/CustomButton";
import CustomSelect from "../../common/CustomSelect";
import { getAllAmbulancesApi } from "../../apis/ambulance";
import { getAllCrewEmployeesWithoutPaginationApi, addManualAttendnaceApi } from "../../apis/crewEmployee";
import SelectCrewMember from "../SelectCrewMember";
import { showNotification } from "../../redux/actions/notification";

import dayjs from "dayjs";

const shiftTypeOptions = [
  { value: "SHIFT_8AMTO8PM", label: "Day Shift" },
  { value: "SHIFT_8PMTO8AM", label: "Night Shift" }
];

const AddAttendance = () => {
  const [attendanceDetails, setAttendnaceDetails] = useState({})
  const [crewMembers, setCrewMembers] = useState([]);
  const dispatch = useDispatch();
  
  useEffect(() => {
    async function fetchCrewMembers() {
      try {
        const response = await getAllCrewEmployeesWithoutPaginationApi();
        if (response) {
          setCrewMembers(response);
        }
      } catch (error) {
        console.error("Failed to fetch crew members:", error);
      }
    }

    fetchCrewMembers();
  }, []);

  const handleAddLeader = async () => {
    try {
      if (
        !attendanceDetails.ambulanceNumber ||
        !attendanceDetails.employeeId ||
        !attendanceDetails.date ||
        !attendanceDetails.shiftType
      ) {
        dispatch(
          showNotification({
            type: "error",
            message: "Please fill all required fields",
          })
        );
        return;
      }
  
      const ambulanceId = await getAmbulanceId();
  
      if (!ambulanceId) return;
  
      const payload = {
        date: attendanceDetails.date,
        employeeId: attendanceDetails.employeeId,
        ambulanceId: ambulanceId,
        shiftStatus: "COMPLETED",
        shiftType: attendanceDetails.shiftType,
        remarks: attendanceDetails.remarks || "",
        geofencingEnabled: true,
      };
  
      const response = await addManualAttendnaceApi(payload);
  
      dispatch(
        showNotification({
          type: "success",
          message: "Attendance created successfully",
        })
      );
  
      setAttendnaceDetails({});
  
    } catch (error) {
      console.error("Error creating attendance:", error);
      dispatch(
        showNotification({
          type: "error",
          message: "Failed to create attendance",
        })
      );
    }
  };
   

  const getAmbulanceId = async () => {
    try {
      if (!attendanceDetails.ambulanceNumber) {
        dispatch(showNotification({
          type: "error",
          message: "Invalid or Empty Ambulance Number"
        }))
        return;
      }
  
      const response = await getAllAmbulancesApi({searchText: attendanceDetails.ambulanceNumber});
  
      const ambulanceList = response?.data?.content || [];
      
      const matchedAmbulance = ambulanceList[0];
  
      if (!matchedAmbulance) {
        dispatch(showNotification({
          type: "error",
          message: "Ambulance Not found with this Number"
        }))
        return;
      }

      return matchedAmbulance?.id;
  
    } catch (error) {
      console.error("Error fetching ambulances:", error);
    }
  };
  

  const handleFromDateChange = (date, dateString) => {
    setAttendnaceDetails((prev) => ({ ...prev, date: dateString }));
  };

  return (
    <Card 
      title={"Create Attenance"}
      bordered
      style={{ border: "2px solid rgb(0, 168, 204)"}}
      styles={{
        header: { borderBottom: "2px solid rgb(0, 168, 204)", fontSize: "2rem", textAlign: "center", color: "rgb(0, 168, 204)"},
      }}
      >
      <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", marginBottom: "1rem" }}>
        <div>
          <label>Date:</label><br />
          <DatePicker
            style={{ width: 220 }}
            value={attendanceDetails.date ? dayjs(attendanceDetails.date) : null}
            format="YYYY-MM-DD"
            onChange={handleFromDateChange}
            disabledDate={(current) => {
              const allowedDates = [
                dayjs().startOf("day"),
                dayjs().subtract(1, "day").startOf("day"),
                dayjs().subtract(2, "day").startOf("day")
              ];
              return !allowedDates.some(date => current.isSame(date, "day"));
            }}
          />
        </div>

        <CustomInput
          label={"Ambulance Number"}
          placeholder="Enter Ambulance Number"
          value={attendanceDetails?.ambulanceNumber}
          onChange={(e) =>
            setAttendnaceDetails({
              ...attendanceDetails,
              ambulanceNumber: e.target.value,
            })
          }
          required={true}
          requiredMessage="Ambulance Number is required"
          style={{ width: 220 }}
        />

        <SelectCrewMember
          value={attendanceDetails.employeeId}
          onChange={(value) =>
            setAttendnaceDetails((prev) => ({ ...prev, employeeId: value }))
          }
        />

        <CustomSelect
          label="Select Shift Type"
          placeholder="Select Shift Type"
          value={attendanceDetails.shiftType}
          onChange={(value) =>
            setAttendnaceDetails((prev) => ({ ...prev, shiftType: value }))
          }
          options={shiftTypeOptions}
          mode="single"
          style={{ width: 220 }}
        />
      </div>

      {/* Add this for Remarks field */}
      <CustomInput
        label="Remarks"
        placeholder="Enter any remarks"
        type="textarea"
        value={attendanceDetails?.remarks}
        onChange={(e) =>
          setAttendnaceDetails((prev) => ({ ...prev, remarks: e.target.value }))
        }
        style={{ width: "100%", marginBottom: "1rem" }}
      />

      <div>
        <CustomButton 
          type="primary" 
          onClick={handleAddLeader}
          title={"Add Attendance"}
        />
      </div>
    </Card>
  );
};

export default AddAttendance;
